class SpinTonDealClaimed extends HTMLElement {
  constructor() {
    super()
    this._timerInterval = null
  }

  connectedCallback() {

    this.setupCopyButtons()
    this.setupApplyButtons()
    this.setupTimer()
  }

  disconnectedCallback() {

    if (this._timerInterval) {
      clearInterval(this._timerInterval)
      this._timerInterval = null
    }
  }

  setupCopyButtons() {
    const buttons = this.querySelectorAll('button[data-code]')

    buttons.forEach((button) => {
      if (button._stdCopyBound) return
      button._stdCopyBound = true

      let timeoutId

      button.addEventListener('click', (e) => {
        e.preventDefault()

        const code = button.dataset.code
        if (!code) return

        const originalText = button.textContent.trim()
        const copiedLabel = button.dataset.copiedLabel || originalText

        navigator.clipboard
          .writeText(code)
          .then(() => {
            button.textContent = copiedLabel

            if (timeoutId) clearTimeout(timeoutId)

            timeoutId = setTimeout(() => {
              button.textContent = originalText
            }, 1000)
          })
          .catch((err) => {
            console.error('[STD] Could not copy text: ', err)
          })
      })
    })
  }

  // ---------------- APPLY CODES ----------------
  setupApplyButtons() {
    const buttons = this.querySelectorAll('button[data-discount-code]')

    buttons.forEach((button) => {
      if (button._stdApplyBound) return
      button._stdApplyBound = true

      button.addEventListener('click', (e) => {
        e.preventDefault()
        const code = button.dataset.discountCode
        if (!code) return
        this.addDiscountCode(code)
      })
    })
  }

  async addDiscountCode(newCode) {
    try {
      const cartRes = await fetch(`${window.Shopify.routes.root}cart.js`)
      const cart = await cartRes.json()

      const codes = new Set()

      ;(cart.cart_level_discount_applications || []).forEach((app) => {
        if (app.type === 'discount_code') {
          codes.add(app.title)
        }
      })

      ;(cart.items || []).forEach((item) => {
        ;(item.line_level_discount_allocations || []).forEach((alloc) => {
          if (alloc.discount_application?.type === 'discount_code') {
            codes.add(alloc.discount_application.title)
          }
        })
      })

      if (newCode) {
        codes.add(newCode)
      }

      const discountString = Array.from(codes).join(',')

      const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: discountString }),
      })

      if (!res.ok) {
        console.error('[STD] Failed to update discounts')
      } else {
        window.refreshCart && window.refreshCart()
      }
    } catch (e) {
      console.error('[STD] addDiscountCode error', e)
    }
  }

  // ---------------- COUNTDOWN ----------------
  setupTimer() {
    const el = this.querySelector('.claimed-info-text-timer')
    if (!el) return

    const wonAtSeconds = parseInt(el.dataset.wonAt || '0', 10)
    if (!wonAtSeconds || Number.isNaN(wonAtSeconds)) {
      el.textContent = '00:00'
      return
    }

    const WON_AT = wonAtSeconds * 1000
    const DURATION = 30 * 60 * 1000 // 30 minutes
    const DEADLINE = WON_AT + DURATION

    if (this._timerInterval) {
      clearInterval(this._timerInterval)
    }

    const formatTime = (msLeft) => {
      const totalSeconds = Math.floor(msLeft / 1000)
      const minutes = Math.floor(totalSeconds / 60)
      const seconds = totalSeconds % 60

      const mm = String(minutes).padStart(2, '0')
      const ss = String(seconds).padStart(2, '0')

      return `${mm}:${ss}`
    }

    const tick = () => {
      const now = Date.now()
      const diff = DEADLINE - now

      if (diff <= 0) {
        el.textContent = '00:00'
        clearInterval(this._timerInterval)
        this._timerInterval = null
        return
      }

      el.textContent = formatTime(diff)
    }

    tick()
    this._timerInterval = setInterval(tick, 1000)
  }
}

customElements.define('spin-ton-deal-claimed', SpinTonDealClaimed)
